module.exports = __webpack_public_path__ + "static/img/TYZX.0c96046.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/TYZX.png
// module id = 21Wz
// module chunks = 34